import React from 'react';
import * as Highcharts from 'highcharts';

import { useRecoilValueLoadable } from 'recoil';
import { timeSavedChartOptions } from '../../../recoil/selectors/timeSavedChartOptions';
import { HighchartsReactWithStyles } from './HighchartsReactWithStyles';

export function TimeSavedBarChart() {
  const timeSavedReporting = useRecoilValueLoadable(timeSavedChartOptions);
  /** @type {Highcharts.Options} */
  const highchartsOptions = timeSavedReporting.contents?.options?.series
    ? {
        ...timeSavedReporting.contents?.options,
        // https://github.com/reduxjs/redux-toolkit/issues/1437
        series: JSON.parse(
          JSON.stringify(timeSavedReporting.contents?.options?.series)
        ),
      }
    : undefined;

  return (
    <div>
      <HighchartsReactWithStyles
        allowChartUpdate={true}
        highcharts={Highcharts}
        options={highchartsOptions}
        loading={timeSavedReporting.state === 'loading'}
      />
    </div>
  );
}
